const Calificacion = ({ calificationUser }: any) => {
  return (
    <span>
      {calificationUser === null || calificationUser === undefined
        ? "Pendiente"
        : `${calificationUser}%`}
    </span>
  );
};
export default Calificacion;
